import React from 'react';
import {
  FDPaper, FDHeadlineText, FDStack, FDTitleText, FDIcon, FDBodyText,
} from '@facet-wealth/design';
import useMobileLayout from 'Hooks/useMobileLayout';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { DataValueMap } from 'Helpers/Testing';

const MCISection = ({ sectionResource: resource }) => {
  const sections = resource.attr('sections').resources().list();
  const isMobile = useMobileLayout();
  return (
    <FDPaper width={'100%'} padding={'500'} {...DataValueMap.init('monthly-check-in-section').build()}>
      <FDStack direction={'column'} spacing={4}>
        <FDHeadlineText value={resource.attr('title')} size={'lg'} />
        <FDStack direction={isMobile ? 'column' : 'row'} spacing={4} alignItems={'center'}>
          {sections.map((section) => (
            <FDStack direction={'column'}>
              <FDIcon icon={section.attr('icon')} color={section.attr('iconColor')} />
              <FDTitleText size={'lg'} value={section.attr('title')} />
              <FDBodyText size={'sm'} color={'textDisabled'} value={section.attr('body')} />
            </FDStack>
          ))}
        </FDStack>
      </FDStack>
    </FDPaper>
  );
};

MCISection.defaultProps = {};

MCISection.propTypes = {
  sectionResource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export { MCISection };
